<div class="type-selection-container" *ngIf="selectedCategory">
    <div class="selected-category-title">
        <h2>{{ 'permit.create.permit_type.category_title' | translate }}</h2>
    </div>

    <div class="selected-category-container">
        <div class="selected-category-display">
            <i [ngClass]="(selectedCategory.icon || 'icon-folder') + ' category-icon'"></i>
            <div class="category-content">
                <h3 class="category-title">{{ localizedName(selectedCategory.name) }}</h3>
            </div>
        </div>
    </div>

    <div class="dialog-title-section">
        <h2 class="dialog-title">{{ 'permit.create.permit_type.title' | translate }}</h2>
    </div>

    <div class="search-container">
        <div class="search-input-wrapper">
            <i class="search-icon icon-search"></i>
            <input type="text" class="search-input" [(ngModel)]="searchQuery" (ngModelChange)="onSearchChange()" [placeholder]="'permit.create.permit_type.search_placeholder' | translate" />
        </div>
    </div>

    <div class="types-container">
        <div *ngFor="let type of filteredTypes" class="type-item" [class.selected]="isSelected(type)" (click)="selectType(type)" role="option" [attr.aria-selected]="isSelected(type)">
            <div class="type-text">
                <h3 class="type-title">{{ localizedName(type.name) }}</h3>
                <span class="type-subtitle" *ngIf="typeSubtitle(type)">{{ typeSubtitle(type) }}</span>
            </div>
            <span class="type-fee" *ngIf="feeHint(type)">{{ feeHint(type) }}</span>
        </div>

        <div class="skeleton-loader-container" *ngIf="loading">
            <app-skeleton-loader class="skeleton-loader" height="56px" *ngFor="let i of [1, 2, 3]"></app-skeleton-loader>
        </div>

        <div class="no-results" *ngIf="filteredTypes.length === 0 && !loading">
            <h3 class="no-results-title">{{ 'permit.create.permit_type.empty_title' | translate }}</h3>
            <p class="no-results-description">{{ 'permit.create.permit_type.empty_description' | translate }}</p>
        </div>
    </div>
</div>
